import { render, staticRenderFns } from "./animated_button.vue?vue&type=template&id=70c962f5&"
import script from "./animated_button.vue?vue&type=script&lang=js&"
export * from "./animated_button.vue?vue&type=script&lang=js&"
import style0 from "./animated_button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports